import api from 'api'

export const fetchForm = async (id) => {
  const { data } = await api.get(
    `/form/${id}`
  )

  return data
}
